"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathLight = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#1D1D1B",
    d: "M169.66,104.235c-0.124-10.51-3.06-18.595-8.719-24.031c-5.474-5.237-13.359-7.898-23.459-7.898H62.269\r c-1.207,0-2.376,0.037-3.52,0.112V44.295c0-21.045,18.073-38.173,40.287-38.173h1.928c22.216,0,40.276,17.127,40.276,38.173\r c0,1.555,1.269,2.811,2.811,2.811c1.556,0,2.812-1.256,2.812-2.811c0-24.143-20.586-43.795-45.898-43.795h-1.928\r c-25.311,0-45.909,19.652-45.909,43.795v28.857c-5.821,1.157-10.61,3.52-14.279,7.065c-5.66,5.448-8.52,13.545-8.52,24.056v0.025\r c0,0.012,0.012,1.293,0.037,4.515l-0.037,58.733c0,10.511,2.86,18.607,8.52,24.055c5.436,5.237,13.321,7.899,23.421,7.899h75.214\r c10.1,0,17.985-2.649,23.459-7.899c5.659-5.422,8.595-13.507,8.719-24.018c0.013-0.012,0.013-0.025,0.013-0.037v-63.273\r C169.673,104.26,169.673,104.248,169.66,104.235z M163.702,167.533c-0.211,17.501-8.794,26.009-26.22,26.009H62.269\r c-8.508,0-15-2.103-19.292-6.231c-4.44-4.279-6.691-10.933-6.691-19.765l0.05-58.745v-0.026c-0.025-3.034-0.038-4.365-0.05-4.526\r c0.012-8.819,2.263-15.461,6.691-19.74c4.292-4.142,10.784-6.231,19.292-6.231h75.214c17.426,0,26.009,8.508,26.22,26.009V167.533z"
  })
});
var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M162.782,80.785c-5.791-5.542-14.035-8.356-24.509-8.356h-76V45.742c0-19.152,16.5-34.731,36.787-34.731h1.88\r c20.287,0,36.787,15.579,36.787,34.731c0,2.901,2.354,5.255,5.255,5.255s5.255-2.354,5.255-5.255\r c0-24.943-21.221-45.242-47.297-45.242h-1.88c-26.077,0-47.297,20.299-47.297,45.242v27.633c-5.977,1.233-10.921,3.724-14.757,7.422\r c-5.99,5.778-9.028,14.235-9.028,25.156c0,0.124,0,0.249,0.013,0.373c0,0.237,0.012,0.859,0.025,2.354l-0.038,57.296\r c0,10.921,3.038,19.389,9.028,25.155c5.753,5.555,13.998,8.368,24.483,8.368h76.785c10.474,0,18.718-2.802,24.509-8.355\r c6.001-5.754,9.103-14.197,9.24-25.094v-60.16C171.885,94.982,168.783,86.538,162.782,80.785z M161.512,165.951\r c-0.2,15.716-7.584,23.038-23.238,23.038H61.489c-15.691,0-23.001-7.31-23.001-23l0.038-57.322v-0.036\r c-0.013-1.259-0.013-1.956-0.025-2.343v-0.447c0-0.037-0.013-0.062-0.013-0.1c0.062-15.555,7.385-22.802,23.001-22.802h76.785\r c15.654,0,23.038,7.323,23.238,23.038V165.951z"
  })
});
var pathSolid = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M172,105.9V166c-0.1,10.9-3.2,19.3-9.2,25.1c-5.8,5.6-14,8.4-24.5,8.4H61.5c-10.5,0-18.7-2.8-24.5-8.4c-6-5.8-9-14.2-9-25.1\r l0-57.3c0-1.5,0-2.1,0-2.3c0-0.1,0-0.2,0-0.4c0-10.9,3-19.4,9-25.2c3.8-3.7,8.8-6.2,14.8-7.4V45.7C51.8,20.8,73,0.5,99.1,0.5h1.9\r c26.1,0,47.3,20.3,47.3,45.2c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.2-2.4-5.2-5.3c0-19.2-16.5-34.7-36.8-34.7h-1.9\r c-20.3,0-36.8,15.6-36.8,34.7v26.7h76c10.5,0,18.7,2.8,24.5,8.4C168.8,86.5,171.9,95,172,105.9z"
  })
});

var Abierto = function Abierto(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    case _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT:
      path = pathLight;
      break;

    case _gerenciatdUnifiedicons.SVG_ICON_KIND.SOLID:
      path = pathSolid;
      break;

    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '22 0 150 199';
  }

  if (!mainDimension) {
    mainDimension = 'y';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Abierto-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Abierto;
exports["default"] = _default;

//# sourceMappingURL=index.js.map